export default __webpack_public_path__ + "static/media/element_82.39f15d6d.webp";